import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEmbyComponent } from './simple-icons-emby.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEmbyComponent ],
    exports:      [ SimpleIconsEmbyComponent ],
    bootstrap:    []
})
export class SimpleIconsEmbyModule {}
